import * as React from 'react';
import GatsbyImage from 'gatsby-image';
import { useStaticQuery, graphql, Link } from 'gatsby';

import { useGraphQL } from '../hooks';

function OurStory() {
  const { heroOurStoryImage } = useStaticQuery(graphql`
    {
      heroOurStoryImage: file(relativePath: { eq: "about/our-story.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 1280) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `);

  const {
    site: {
      siteMetadata: { title },
    },
  } = useGraphQL();
  return (
    <article className="relative bg-white">
      <GatsbyImage
        fluid={heroOurStoryImage.childImageSharp.fluid}
        className="relative max-h-96"
      />

      <div className="px-4 py-12 pb-24 sm:px-6 lg:px-8 lg:pt-16">
        <h2 className="h2">A Little About {title}</h2>
        <div aria-hidden className="flex w-1/3 h-3 mt-6 overflow-hidden">
          <div className="w-1/2 bg-brand-pink">
            <div className="h-full transform -skew-x-12 bg-brand-pink" />
          </div>
          <div className="w-1/2 bg-brand-blue">
            <div className="h-full transform -skew-x-12 bg-brand-blue" />
          </div>
        </div>
        <div className="grid gap-8 mt-8 lg:grid-cols-3">
          <div className="prose">
            <p>
              {title} was established in 2016 by enthusiasts and professionals
              Chantale and Gordon McCallum, opening a retail shop in Port
              Macquarie, NSW, Australia.
            </p>
            <p>
              {title} began life as Golf Ladies First, with an aim to support
              and encourage women golfers to take up and enjoy the sport. Our
              mission is to facilitate a relaxed and friendly in-store
              atmosphere, providing options beyond what’s generally available at
              most male-centric golf shops.
            </p>
            <p>
              {title} stocks a diverse range of apparel, accessories, and
              everything golfing ladies require for competitive and casual play.
            </p>
          </div>
          <div className="prose">
            <p>
              As of 2020, in addition to our premier collection for women,
              {title} has evolved into offering quality attire and accessories
              for men.
            </p>
            <p>
              {title} stocks outerwear, shirts, shoes, socks, shorts, skorts,
              skirts, capris, pants, dresses, headwear, and golfing accessories.
              Want to buy a gift for your fellow golf lover? Not sure what to
              pick?{' '}
              <Link
                to="/ladies/collections/gift-certificate/"
                className="font-bold underline"
              >
                Click here
              </Link>{' '}
              to buy a gift voucher!
            </p>
            <p>
              {title} is proud to retail the finest quality and world-renowned
              golf brands available in our store and online. {title} stocks gear
              from top brands such as Annika, Greg Norman, Nivo, Bermuda Sands,
              Travis Matthew, Cutter & Buck, and more.{' '}
              <Link
                to="/ladies/collections/clearance-items/"
                className="font-bold underline"
              >
                Check here
              </Link>{' '}
              for our current collections and clearance sales.
            </p>
          </div>
          <div className="prose">
            <p>
              Our fast dispatch system ensures you can hit the links sooner,
              shipping orders throughout the day.
            </p>
            <p>
              We’re always on hand to lend advice, share tips on play, and use
              our knowledge to understand your clubs’ dress code requirements
              and recommend apparel accordingly. We stock attire for traditional
              clubs as well as more relaxed and contemporary designs – whatever
              your playing style and wherever you play, {title} has you covered.
            </p>
            <p>
              Click through to shop from our extensive range for{' '}
              <Link to="/ladies/" className="font-bold underline">
                women
              </Link>{' '}
              and{' '}
              <Link to="/mens/" className="font-bold underline">
                men
              </Link>
              .
            </p>
          </div>
        </div>
      </div>
    </article>
  );
}

export { OurStory };
